export const detailField = {
    "POSITION": "Позиция",
    "NAME": "Наименование",
    "LENGTH": "L",
    "WIDTH": "W",
    "TURN": "Поворот",
    "CUT": "Кроить",
    "L1": "l1",
    "L1_NAME": "l1Name",
    "L2": "l2",
    "L2_NAME": "l2Name",
    "W1": "w1",
    "W1_NAME": "w1Name",
    "W2": "w2",
    "W2_NAME": "w2Name",
    "GROOVE": "Паз",
    "QUANTITY": "Количество",
    "MATERIAL_NAME": "Наименование материала",
    "HEIGHT": "H",
    "ORDER_NUMBER": "Номер заказа",
    "ORDER_NUMBER_CUSTOMER": "Номер заказа кастомера",
    "STRUCTURE": "Структура",
}